import { create } from 'zustand';

type UseCustomsDocumentStatusReferentialState = {
  customsDocumentStatusReferential: Map<string, string>;
  setCustomsDocumentStatusReferential: (customsDocumentsStatus: Map<string, string>) => void;
};

export const useCustomsDocumentStatusReferentialState = create<UseCustomsDocumentStatusReferentialState>((set) => ({
  customsDocumentStatusReferential: new Map(),
  setCustomsDocumentStatusReferential: (customsDocumentStatusReferential: Map<string, string>) =>
    set(() => ({ customsDocumentStatusReferential })),
}));
